// extracted by mini-css-extract-plugin
export default {"header":"Header_header__stqK6","gridContainer":"Header_gridContainer__p1fKv"};